<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.667 4.853L8 8m0 0L2.333 4.853M8 8v6.333m6-3.628V5.294c0-.228 0-.342-.033-.444a.93.93 0 00-.143-.243c-.073-.079-.173-.134-.373-.245L8.518 1.621c-.189-.105-.283-.157-.383-.178a.67.67 0 00-.269 0c-.1.021-.194.073-.383.178L2.549 4.362c-.2.111-.3.166-.372.245a.93.93 0 00-.143.243c-.034.102-.034.216-.034.444v5.411c0 .229 0 .343.034.445.03.09.078.173.143.243.072.079.172.134.372.245l4.933 2.741c.19.105.283.157.383.178a.67.67 0 00.269 0c.1-.021.194-.073.383-.178l4.933-2.741c.2-.111.3-.166.373-.245a.93.93 0 00.143-.243c.033-.102.033-.216.033-.445z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
